<script>
  import { transactionStore } from '../../stores';
  import { config } from '../../../scripts/defaultURL';
  import { clearForm, formatDate } from '../../../scripts/functions';
  import { postData } from '../../../scripts/rest';

  export let clientOptions;
  export let categoryOptions;

  let client_id;
  let payload = {
    date: formatDate(new Date())
  };

  function closeModal() {
    clearForm('input');
    payload = {
      date: formatDate(new Date())
    };
    document.getElementById('transactionsModal').classList.remove('is-active')
    if (!$transactionStore) $transactionStore = {};
    $transactionStore['todo'] = 'getData';
  }

  function save() {
    if (typeof client_id == 'number') payload.client_id = client_id;

    postData(`${config.defaultURL}/transactions/add`, payload)
    .catch((error) => console.error('Failed to post transaction:', error))
    .then((res) => {
      console.log(res)
      closeModal()
    })
  }
</script>

<style>
  .modal-card-title {
    margin-bottom: 0 !important;
  }
</style>

<div class="modal" id="transactionsModal">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Add Transaction</p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <div class="columns">
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Income/Expense?</label>
            <div class="control">
              <label class="radio">
                <input type="radio" bind:group={payload.income_expense} name="income_expense" value="income">
                Income
              </label>
              <label class="radio">
                <input type="radio" bind:group={payload.income_expense} name="income_expense" value="expense">
                Expense
              </label>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Date</label>
            <input bind:value={payload.date} type="date" class="input" name="date" placeholder="Date Of Transaction" />
          </div>          
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Amount</label>
            <input bind:value={payload.amount} type="text" class="input" name="amount" placeholder="Transaction Amount" />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Description</label>
            <input bind:value={payload.description} type="text" class="input" name="description" placeholder="Transaction Description" />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Category</label>
            <input list="categories" class="input" name="Category" placeholder="Category (optional)" bind:value={payload.category} />
            <datalist id="categories">
              {#each categoryOptions as category}
              <option>{category}</option>
              {/each}
            </datalist> 
          </div>
        </div>
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Client</label>
            <div class="select">
              <select bind:value={client_id} name="client_id">
                <option value=null>Select Client</option>
                {#each clientOptions as opt}
                <option value={opt.id}>{opt.first} {opt.last}</option>
                {/each}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button on:click={save} class="button is-primary">Submit</button>
        </div>
        <div class="control">
          <button
            on:click={closeModal}
            class="button is-primary is-light">Cancel</button>
        </div>
      </div>
    </section>
  </div>
</div>
